import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";
import "bootstrap";

export default class NavTabs extends React.Component {
  static generateConfigTab(syncStatus, disabled, onClick) {
    let tabIcon;

    switch (syncStatus) {
    case "Failed":
      tabIcon = <TabIcon syncStatus={'error'} />;
      return <ConfigurationTab disabled={disabled} tabIcon={tabIcon} onClick={onClick}/>;
    case "Pending":
      tabIcon = <TabIcon syncStatus={'warning'} />;
      return <ConfigurationTab disabled={disabled} tabIcon={tabIcon}/>;
    default:
      return <ConfigurationTab disabled={disabled} onClick={onClick}/>;
    }
  }

  render() {
    const configTab = NavTabs.generateConfigTab(this.props.syncStatus, this.props.disabled, this.props.onClick);

    return (
      <ul className="nav nav-tabs">
        <li className="nav-item active">
          <a className="nav-link" data-navigation="overview" onClick={this.props.onClick} href="#">Overview</a>
        </li>
        <li className="nav-item">{configTab}</li>
        <li className="ml-auto">
          <button className="btn btn-default" data-test-id="deactivate-button" onClick={this.props.onDeactivate}>Deactivate</button>
        </li>
      </ul>
    );
  }
}

NavTabs.propTypes = {
  syncStatus: PropTypes.oneOf(['Complete', 'Failed', 'Pending']).isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired
};

function ConfigurationTab({ disabled, tabIcon, onClick }) {
  return (
    <a className={classNames('nav-link', { 'disabled allow-pointer-events': disabled })} data-navigation="configuration" onClick={onClick} href="#" disabled={disabled}>
      Configuration {tabIcon}
    </a>
  );
}

ConfigurationTab.propTypes = {
  disabled: PropTypes.bool.isRequired,
  tabIcon: PropTypes.node,
  onClick: PropTypes.func
};

ConfigurationTab.defaultProps = {
  onClick: function() { event.preventDefault(); }
};

function TabIcon({ syncStatus }) {
  return (
    <i className={classNames('material-icons icon--status', `color-${syncStatus}`)}>{syncStatus}</i>
  );
}

TabIcon.propTypes = {
  syncStatus: PropTypes.string.isRequired
};
